import React from 'react'
import Core from './Core'
import Flash from './Flash'
import CheckerBackground from './CheckerBackground'

const Camera = () => {
  return (
    <>
      <Core />
      <Flash />
      <CheckerBackground />
    </>
  )
}

export default Camera
